import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import React, { memo } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import IconCheck from "../../../assets/images/booking/check-circle.svg";
import IconRed from "../../../assets/images/booking/x-red.svg";
import toast from "react-hot-toast";
import { contractCall } from "../../../api/contract";
import PopupProjectManagementTitle from "../../../components/popup/popupProjectManagementTitle";
import PopupApartmentInfo from "../../../components/popup/popupApartment";
import FormInfoBusiness from "../../customers/formCustomers/formInfoBusiness";
import FormInfoCustomer from "../../customers/formCustomers/formInfo";
import FormInfoEmployee from "../../../components/form/formInfo";
import ImagePreviewZoom from "../../../components/ImagePreviewZoom";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const FormInfo = memo(({ isOpen, onClose, defaultValues, refetch }) => {
  const {
    isOpen: isOpenProject,
    onOpen: onOpenProject,
    onClose: onCloseProject,
  } = useDisclosure();
  const {
    isOpen: isOpenApartment,
    onOpen: onOpenApartment,
    onClose: onCloseApartment,
  } = useDisclosure();
  const {
    isOpen: isOpenCustomer,
    onOpen: onOpenCustomer,
    onClose: onCloseCustomer,
  } = useDisclosure();
  const {
    isOpen: isOpenApproved,
    onOpen: onOpenApproved,
    onClose: onCloseApproved,
  } = useDisclosure();
  const {
    isOpen: isOpenCreator,
    onOpen: onOpenCreator,
    onClose: onCloseCreator,
  } = useDisclosure();
  const submitStatus = async (status) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await contractCall.approve(defaultValues?.id, dataFormat);
      refetch();
      onClose();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <Box
          paddingBottom={"80px"}
          h={"86.5vh"}
          w={"100%"}
          overflowY={"auto"}
          sx={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
            "&::-moz-scrollbar": {
              width: "4px",
            },
            "&::-moz-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
          }}
        >
          <Flex
            alignItems={"center"}
            p={"25px 24px 24px 24px"}
            position={"relative"}
            borderBottom={
              defaultValues?.status === "APPROVED" ||
              defaultValues?.status === "REJECTED"
                ? ""
                : "1px solid var(--border-input-employee)"
            }
          >
            <Text
              color={"var(--color-header-employee)"}
              fontSize={"16px"}
              fontWeight={"600"}
            >
              Chi tiết TTKQ
            </Text>
            <Box
              position={"absolute"}
              top={"24px"}
              right={"24px"}
              cursor={"pointer"}
              onClick={onClose}
            >
              <Image src={IconX} />
            </Box>
          </Flex>
          {(defaultValues?.status === "APPROVED" ||
            defaultValues?.status === "REJECTED") && (
            <Flex
              p={"16px 24px"}
              justifyContent={"space-between"}
              bg={
                defaultValues?.status === "APPROVED"
                  ? "var(--bg-green-1)"
                  : "var(--bg-red-1)"
              }
            >
              {defaultValues?.status === "APPROVED" && (
                <Flex
                  p={"12px"}
                  justifyContent={"space-between"}
                  gap={"8px"}
                  bg={"var(--bg-status-success)"}
                  borderRadius={"8px"}
                  w={"max-content"}
                  minW={"151px"}
                  h={"max-content"}
                >
                  <Image
                    src={IconCheck}
                    w={"20px"}
                    h={"20px"}
                    objectFit={"cover"}
                  />
                  <Text
                    fontSize={"14px"}
                    lineHeight={"20px"}
                    fontWeight={500}
                    color={"var(--color-status-employ)"}
                    display={"block"}
                  >
                    Đã được duyệt
                  </Text>
                </Flex>
              )}
              {defaultValues?.status === "REJECTED" && (
                <Flex
                  p={"12px"}
                  justifyContent={"space-between"}
                  gap={"8px"}
                  bg={"var(--bg-status-error)"}
                  borderRadius={"8px"}
                  w={"max-content"}
                  minW={"176px"}
                  h={"max-content"}
                >
                  <Image
                    src={IconRed}
                    w={"20px"}
                    h={"20px"}
                    objectFit={"cover"}
                  />
                  <Text
                    fontSize={"14px"}
                    lineHeight={"20px"}
                    fontWeight={500}
                    color={"var(--text-red-employee)"}
                    display={"block"}
                  >
                    Không được duyệt
                  </Text>
                </Flex>
              )}

              <Flex gap={"40px"}>
                <Box textAlign={"end"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Người phê duyệt
                  </Text>
                  <Text
                    color={"var(--color-option-employee-hover)"}
                    textDecoration={"underline"}
                    lineHeight={"28px"}
                    cursor={"pointer"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                    onClick={() => onOpenApproved()}
                  >
                    {defaultValues?.approver}
                  </Text>
                </Box>
                <Box textAlign={"end"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Thời gian duyệt
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {defaultValues?.approverDate || ""}
                  </Text>
                </Box>
              </Flex>
            </Flex>
          )}
          <Box
            paddingTop={"24px"}
            paddingBottom={"41px"}
            maxW={"545px"}
            margin={"0 auto"}
          >
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                {defaultValues?.name || ""}
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                mt={"13px"}
                borderRadius={"8px"}
              >
                <Flex gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Người tạo TTKQ
                    </Text>
                    <Text
                      color={"var(--color-option-employee-hover)"}
                      textDecoration={"underline"}
                      lineHeight={"28px"}
                      cursor={"pointer"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                      onClick={() => onOpenCreator()}
                    >
                      {defaultValues?.creator || ""}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Ngày tạo TTKQ
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.createdAt || ""}
                    </Text>
                  </Box>
                </Flex>
                <Flex gap={"27px"} mt={"16px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Khối
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.saleBlock || "-"}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Vùng
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.saleArea || "-"}
                    </Text>
                  </Box>
                </Flex>
                <Flex mt={"16px"} gap={"27px"}>
                  {/* <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Phiếu tính giá
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.invoice || ""}
                    </Text>
                  </Box> */}
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Ngày ký TTKQ
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.time || ""}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Phương thức thanh toán
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.paymentMethod || ""}
                    </Text>
                  </Box>
                </Flex>
                <Flex mt={"16px"} gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Số tiền đóng TTKQ
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.price ? `${defaultValues?.price}` : ""}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Ngày đóng tiền TTKQ
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.priceTime || ""}
                    </Text>
                  </Box>
                </Flex>
                {defaultValues?.agentName && (
                  <Flex mt={"16px"} gap={"27px"}>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Đại lý
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {defaultValues?.agentName || ""}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Tên khách hàng
                      </Text>
                      <Text
                        color={"var(--color-option-employee-hover)"}
                        textDecoration={"underline"}
                        lineHeight={"28px"}
                        cursor={"pointer"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                        onClick={() => onOpenCustomer()}
                      >
                        {defaultValues?.customer?.name ||
                          defaultValues?.customerName ||
                          ""}
                      </Text>
                    </Box>
                  </Flex>
                )}

                <Box>
                  <Flex mt={"16px"} gap={"27px"}>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Dự án
                      </Text>
                      <Text
                        color={"var(--color-option-employee-hover)"}
                        textDecoration={"underline"}
                        lineHeight={"28px"}
                        cursor={"pointer"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                        onClick={() => onOpenProject()}
                      >
                        {defaultValues?.project?.name ||
                          defaultValues?.project ||
                          ""}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Sản phẩm
                      </Text>
                      <Text
                        color={"var(--color-option-employee-hover)"}
                        textDecoration={"underline"}
                        lineHeight={"28px"}
                        cursor={"pointer"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                        onClick={() => onOpenApartment()}
                      >
                        {`${defaultValues?.codeApartment || ""} ${
                          defaultValues?.apartment
                            ? `(${defaultValues?.apartment})`
                            : ""
                        }`}
                      </Text>
                    </Box>
                  </Flex>
                  <Flex mt={"16px"} gap={"27px"}>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Số tiền đặt cọc
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {defaultValues?.priceLocking
                          ? `${defaultValues?.priceLocking}`
                          : ""}
                      </Text>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        TG đặt cọc
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {defaultValues?.bookingTime || ""}
                      </Text>
                    </Box>
                  </Flex>
                </Box>

                <Box mt={"16px"}>
                  <Flex flexDirection={"column"}>
                    {defaultValues?.delegationImage &&
                      defaultValues?.delegationImage?.length > 0 && (
                        <Box flex={"1"} mt={4}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Ảnh ủy nhiệm chi
                          </Text>
                          {defaultValues?.delegationImage?.map(
                            (item, index) => (
                              <Flex
                                key={index}
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"100%"}
                                  h={"300px"}
                                >
                                  {/* {item && (
                                    <Image
                                      borderRadius={"11px"}
                                      w={"100%"}
                                      h={"100%"}
                                      objectFit={"contain"}
                                      src={`${baseURL}/${item}`}
                                    />
                                  )} */}
                                  <ImagePreviewZoom
                                    src={`${baseURL}/${item}`}
                                    alt={`anh-uy-nhiem-chi-${index + 1}`}
                                    previewTitle={`Ảnh ủy nhiệm chi ${index + 1}`}
                                  >
                                    <Image
                                      borderRadius={"11px"}
                                      w={"100%"}
                                      h={"100%"}
                                      objectFit={"contain"}
                                      src={`${baseURL}/${item}`}
                                    />
                                  </ImagePreviewZoom>
                                </Box>
                              </Flex>
                            ),
                          )}
                        </Box>
                      )}

                    {defaultValues?.priceSheetImage && (
                      <Box flex={"1"} mt={4}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh ủy phiếu tính giá
                        </Text>
                        <Flex
                          mt={"8px"}
                          border={"0.5px solid var(--bg-line-employee)"}
                          borderRadius={"8px"}
                          justifyContent={"center"}
                        >
                          <Box borderRadius={"11px"} w={"100%"} h={"300px"}>
                            {defaultValues?.priceSheetImage && (
                              // <Image
                              //   borderRadius={"11px"}
                              //   w={"100%"}
                              //   h={"100%"}
                              //   objectFit={"contain"}
                              //   src={`${baseURL}/${defaultValues.priceSheetImage}`}
                              // />
                              <ImagePreviewZoom
                                src={`${baseURL}/${defaultValues.priceSheetImage}`}
                                alt={`Ảnh ủy phiếu tính giá`}
                                previewTitle={`Ảnh ủy phiếu tính giá`}
                              >
                                <Image
                                  borderRadius={"11px"}
                                  w={"100%"}
                                  h={"100%"}
                                  objectFit={"contain"}
                                  src={`${baseURL}/${defaultValues.priceSheetImage}`}
                                />
                              </ImagePreviewZoom>
                            )}
                          </Box>
                        </Flex>
                      </Box>
                    )}

                    {defaultValues?.salesContractImages &&
                      defaultValues?.salesContractImages?.length > 0 && (
                        <Box flex={"1"} mt={4}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Ảnh Hợp Đồng Mua Bán (HDMB)
                          </Text>
                          {defaultValues?.salesContractImages?.map(
                            (item, index) => (
                              <Flex
                                key={index}
                                mt={"8px"}
                                border={"0.5px solid var(--bg-line-employee)"}
                                borderRadius={"8px"}
                                justifyContent={"center"}
                              >
                                <Box
                                  borderRadius={"11px"}
                                  w={"100%"}
                                  h={"300px"}
                                >
                                  {item && (
                                    // <Image
                                    //   borderRadius={"11px"}
                                    //   w={"100%"}
                                    //   h={"100%"}
                                    //   objectFit={"contain"}
                                    //   src={`${baseURL}/${item}`}
                                    // />
                                    <ImagePreviewZoom
                                    src={`${baseURL}/${item}`}
                                    alt={`anh-uy-hdbm-${index + 1}`}
                                      previewTitle={`Ảnh ủy phiếu tính giá`}
                                    >
                                      <Image
                                        borderRadius={"11px"}
                                        w={"100%"}
                                        h={"100%"}
                                        objectFit={"contain"}
                                        src={`${baseURL}/${item}`}
                                      />
                                    </ImagePreviewZoom>
                                  )}
                                </Box>
                              </Flex>
                            ),
                          )}
                        </Box>
                      )}
                  </Flex>
                </Box>

                {/* ảnh locking  */}
                <Box mt={"16px"}>
                  <Flex flexDirection={"column"}>
                    <Box flex={1}>
                      <Box>
                        <Flex flexDirection={"column"}>
                          {defaultValues?.images &&
                            defaultValues?.images?.length > 0 && (
                              <Box flex={"1"}>
                                <Text
                                  color={"var(--color-label-employee)"}
                                  fontSize={"12px"}
                                >
                                  Ảnh ủy nhiệm chi locking
                                </Text>
                                {defaultValues?.images?.map((item, index) => (
                                  <Flex
                                    key={index}
                                    mt={"8px"}
                                    border={
                                      "0.5px solid var(--bg-line-employee)"
                                    }
                                    borderRadius={"8px"}
                                    justifyContent={"center"}
                                  >
                                    <Box
                                      borderRadius={"11px"}
                                      w={"100%"}
                                      h={"300px"}
                                    >
                                      {/* {item && (
                                        <Image
                                          borderRadius={"11px"}
                                          w={"100%"}
                                          h={"100%"}
                                          objectFit={"contain"}
                                          src={`${baseURL}/${item?.path}`}
                                        />
                                      )} */}

                                      <ImagePreviewZoom
                                        src={`${baseURL}/${item?.path}`}
                                        alt={`anh-uy-nhiem-chi-${index + 1}`}
                                        previewTitle={`Ảnh ủy nhiệm chi locking ${index + 1}`}
                                      >
                                        <Image
                                          borderRadius={"11px"}
                                          w={"100%"}
                                          h={"100%"}
                                          objectFit={"contain"}
                                          src={`${baseURL}/${item?.path}`}
                                        />
                                      </ImagePreviewZoom>
                                    </Box>
                                  </Flex>
                                ))}
                              </Box>
                            )}
                        </Flex>
                      </Box>
                    </Box>
                  </Flex>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            position={"absolute"}
            w={"100%"}
            bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
          >
            {defaultValues?.status === "NEW" && (
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-option-employee-hover)"}
                  borderRadius={"8px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  onClick={() => submitStatus("REJECTED")}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Không duyệt
                </Button>
                <Button
                  w={"133px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  onClick={() => submitStatus("APPROVED")}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Duyệt
                </Button>
              </Flex>
            )}
          </Box>
        </Box>
        <PopupProjectManagementTitle
          isOpen={isOpenProject}
          onClose={onCloseProject}
          defaultValue={[]}
          idData={defaultValues?.projectId}
        />
        <PopupApartmentInfo
          isOpen={isOpenApartment}
          onClose={onCloseApartment}
          defaultValue={[]}
          idData={defaultValues?.apartmentId}
        />
        {defaultValues?.customer?.isBusiness ? (
          <FormInfoBusiness
            isOpen={isOpenCustomer}
            onClose={onCloseCustomer}
            defaultValue={[]}
            idData={defaultValues?.customerId}
          />
        ) : (
          <FormInfoCustomer
            isOpen={isOpenCustomer}
            onClose={onCloseCustomer}
            defaultValue={[]}
            idData={defaultValues?.customerId}
          />
        )}
        <FormInfoEmployee
          isOpen={isOpenApproved}
          onClose={onCloseApproved}
          defaultValues={[]}
          idData={defaultValues?.approverId}
        />
        <FormInfoEmployee
          isOpen={isOpenCreator}
          onClose={onCloseCreator}
          defaultValues={[]}
          idData={defaultValues?.creatorId}
        />
      </ModalContent>
    </Modal>
  );
});

export default FormInfo;
